import React from 'react'
import Radio from '@mui/material/Radio'
import * as S from './styles.js'

export function RadioInput({ id, label, error, value, name, data, options = [], handleChange, setData, onChange}) {
	return (<>
		<S.Text>{label}</S.Text>
		<div>
			<S.ControlContainer>
				{options.map(option => {
					const optionId = `${id}-${option.value}`;
					return (
						<S.Control key={optionId}>
							<Radio
							name={name}
							id={optionId}
							checked={value === option.value}
							onChange={handleChange}
							value={option.value}
							inputProps={{ 'aria-label': option.value }}
							color="primary"
							/>
							<S.Label htmlFor="investment-1">
								{option.value}
							</S.Label>
						</S.Control>
					)
				})}
			</S.ControlContainer>
			{error && <div className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">{error}</div>}
		</div>
		
	</>)
}
